import { SCHEDULE_SPECIFIC } from './auctionFormConstants';

/**
 * Keep default v-select item behavior and run callback
 * only for the "Specific time" option.
 */
export function mergeScheduleSpecificItemListeners(item, on, onSpecificPicked) {
  if (!item || item.value !== SCHEDULE_SPECIFIC) return on;
  return {
    ...on,
    click: (e) => {
      if (typeof on.click === 'function') on.click(e);
      if (typeof onSpecificPicked === 'function') onSpecificPicked();
    },
  };
}
